export { EloSecurePurchaseIcon } from './elopage-secure-purchase-icon'
